import React, {
  useCallback,
  useEffect,
  useMemo,
  useReducer,
  useState,
} from "react";
import DynamicStepper from "../../../../genericComponents/uiElements/DynamicStepper";
import DynamicAlertDialog from "../../../../genericComponents/uiElements/DynamicAlertDialog";
import UpdateNurtureDate from "../../../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/UpdateNurtureDate";
import {
  addContactsToCampaign,
  changeCampaignDate,
  checkContactExistsInCampaign,
  createCampaign,
  fetchOutlookToken,
  generateTempalteByContacts,
  getAnalyticsByCampId,
  getContactWiseTemplates,
  nurtureContactSearchSave,
  previewCampaignDetails,
} from "../../../../../../services/iqApiV2";
import * as FeatherIcon from "react-feather";
import WarningForNurtureGate from "../../../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/WarningForNurtureGate";
import { useParams } from "react-router-dom";
import WarningForNurture from "../../../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/WarningForNurture";
import AutoNurtureHelperCard from "../../../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/AutoNurtureHelperCard";
import ReachoutInit from "./ReachoutInit";
import SimpleThemedButton from "../../../../genericComponents/simpleTextField/SimpleThemedButton";
import NurtureCampaignEmailReachOutV2 from "../../../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/NurtureCampaignEmailReachOut/NurtureCampaignEmailReachOutV2";
import {
  formatDateToYMD,
  formatDateWithTime,
} from "../../../../../../utilities/dateUtils";
import { useUser } from "../../../../../../context/UserContext";
import { useSelector } from "react-redux";
import {
  parseContact,
  STEP_IDS,
  templatesReady,
} from "../../../../../../utilities/uiUtils";
import { useUserWiseProductList } from "../../../../../../utilities/memorizedFunctions";
import { useBanner } from "../../../../../../context/BannerContext";
import { fetchAccountInfo } from "../../../../../../services/accIqService";
import GeneratingLoader from "../../../../genericComponents/uiElements/GeneratingLoader";
import { IQ_API_V2_BASE_URL } from "../../../../../../config/apiConfig";
import { Button } from "react-bootstrap";



const initialStepState = {
  [STEP_IDS.CAMPAIGN_INIT]: false,
  [STEP_IDS.EMAIL_REACHOUT]: false,
};
function stepReducer(state, action) {
  switch (action.type) {
    case "MARK_COMPLETED":
      return { ...state, [action.payload]: true };
    case "RESET_STEP":
      return { ...state, [action.payload]: false };
    default:
      return state;
  }
}

function ReachoutV3Wrapper({
  contactId,
  oppDetail,
  contactDetail,
  setShowMoreModal,
}) {
  const [completedSteps, dispatch] = useReducer(stepReducer, initialStepState);
  const [isContinueDisabled, setIsContinueDisabled] = useState(false);
  const { clientName, accountId, accountName } = useParams();
  const [currentCampDetials, setCurrentCampDetails] = useState({});
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  // const [domain, setDomain] = useState("");
  const [searchHist, setSearchHist] = useState("");
  const [prevCampDetails, setPrevCampDetails] = useState({});
  const { user } = useUser();
  const userWiseProductList = useUserWiseProductList(user);
  const [emailsList, setEmailsList] = useState([]);
  const [isCalendarConnected, setIsCalendarDataConnected] = useState(true);
  console.log("Fetched products:", userWiseProductList);

  // getting all opps data
  const { opportunitesData = [] } = useSelector(
    (state) => state.opportunitiesReducer || {}
  );
  const { winOpportunitesData = [] } = useSelector(
    (state) => state.winOpportunitiesReducer || {}
  );
  const allOpps = useMemo(
    () => [...(opportunitesData || []), ...(winOpportunitesData || [])],
    [opportunitesData, winOpportunitesData]
  );
  console.log("ReachoutV3Wrapper allOpps", allOpps);

  const campaignStartDate = currentCampDetials?.startDate
    ? formatDateToYMD(new Date(currentCampDetials?.startDate))
    : formatDateToYMD(new Date());

  const today = formatDateToYMD(new Date());
  const showBanner = useBanner();

  const handleOutlookLogin = () => {
    const pageAfterLoginUrl = window.location.href;

    const afterLoginPageParams = { clientName, accountId, accountName };
    localStorage.removeItem("afterLoginPageParams");
    localStorage.setItem(
      "afterLoginPageParams",
      JSON.stringify(afterLoginPageParams)
    );
    localStorage.setItem("pageAfterLoginUrl", pageAfterLoginUrl);

    const loginWindow = window.open(
      IQ_API_V2_BASE_URL + "/outlook/login",
      "OutlookLogin",
      "width=600,height=500"
    );

    // 🔁 Polling to detect window close
    const checkPopupClosed = setInterval(() => {
      if (loginWindow.closed) {
        clearInterval(checkPopupClosed);
        window.location.reload(); // 🔄 Reload the current page
      }
    }, 500);
  };

  const handleInitAutoNurtureFromReachOut = useCallback(
    async (e) => {
      e?.preventDefault?.();
      e?.stopPropagation?.();
      setDataLoading(true);

      if (!currentCampDetials?.startDate) {
        showBanner({
          message: "Please select a campaign start date.",
          title: "Alert",
          type: "error",
          duration: 7000,
        });
        setDataLoading(false);
        return;
      }

      if (!currentCampDetials?.opportunityId) {
        showBanner({
          message: "Please select an opportunity.",
          title: "Alert",
          type: "error",
          duration: 7000,
        });
        setDataLoading(false);
        return;
      }

      try {
        const startDateStr = formatDateToYMD(
          new Date(currentCampDetials?.startDate)
        );

        const dataObj = {
          title: currentCampDetials?.campaignName,
          start_date: startDateStr,
          context: currentCampDetials?.campaignContext,
          time_gap: 5,
          user_id: user?.id,
          user_name: `${user?.firstname || ""} ${user?.lastname || ""}`.trim(),
          user_email: user?.email,
          client: user?.company_name,
          account: currentCampDetials?.account,
          products: currentCampDetials?.products,
          opportunity_id: currentCampDetials?.opportunityId,
          email_generation_count: currentCampDetials?.emailGenerationCount,
          page_type: "TRO",
          for_contactid: contactId,
          ...(currentCampDetials?.campaignId
            ? { campaignId: currentCampDetials?.campaignId }
            : {}),
        };

        const resp = await createCampaign(dataObj);

        if (!resp?.success || !resp?.campaign_id) {
          throw new Error("Campaign creation failed.");
        } else {

          try {
            const searchList = {
            currentStepId: STEP_IDS.CAMPAIGN_INIT,
              };
    
    
              await nurtureContactSearchSave(
                resp?.campaign_id,
                searchList
              ) 
          } catch (error) {
            console.log("nurtureContactSearchSave err",error)
          }

          setCurrentCampDetails((prev) => ({
            ...prev,
            campaignId: resp?.campaign_id,
            account: accountName,
            startDate: Date.now(),
            daysFrequency: 3,
          }));
        }
        let domain = null;
        const response = await fetchAccountInfo(accountName);
        if (response?.organization_website) {
          domain = response.organization_website;
        }
        const searchList = {
          domain: domain,
          titles: [],
          person_locations: [],
          person_seniorities: [],
          page: 1,
          per_page: 50,
          currentStepId: STEP_IDS.CONTACT,
        };

        const addContactResp = await addContactsToCampaign(
          resp.campaign_id,
          [contactDetail].map(parseContact),
          searchList
        );

        const newContactId = addContactResp?.inserted?.[0]?._id;
        if (!newContactId) {
          throw new Error("Contact could not be added to the campaign.");
        }

        if (resp.campaign_id !== currentCampDetials?.campaignId) {
          setCurrentCampDetails((prev) => ({
            ...prev,
            campaignId: resp.campaign_id,
          }));
        }

        generateTempalteByContacts(
          user?.company_name ?? "",
          accountName,
          currentCampDetials?.campaignName ?? "",
          currentCampDetials?.campaignContext ?? "",
          [newContactId],
          user?.id,
          resp.campaign_id
        );
      } catch (error) {
        console.error("error", error);
        showBanner({
          message: error?.message || "Error while creating campaign",
          title: "Alert",
          type: "error",
          duration: 10000,
        });
      } finally {
        setDataLoading(false);
      }
    },
    [currentCampDetials]
  );

  useEffect(() => {
    const getOutlookToken = async () => {
      if (user?.id) {
        setDataLoading(true);
        const is_connected = await fetchOutlookToken(user?.id);
        setIsCalendarDataConnected(is_connected);
        //  setDataLoading(false);
        // setIsCalendarDataLoading(true)
        setTimeout(() => {
          //  setIsCalendarDataLoading(false)
          setDataLoading(false);
        }, 30000); // wait for 30 seconds
      }
    };
    getOutlookToken();
  }, [user?.id]);

  useEffect(() => {
    async function bootstrap() {
      try {
        const clientName = user?.company_name;

        setDataLoading(true);

        const ExistingTROdata = await checkContactExistsInCampaign(
          clientName,
          accountName,
          [contactId]
        );
        // the last one it the latest
        const checkBusy =
          ExistingTROdata?.[ExistingTROdata?.length - 1]?.campaign?.[0];
        console.log("checkBusy", checkBusy);
        if (checkBusy?._id) {
          const found =
            allOpps.find(
              (o) =>
                o?.opportunity_id === checkBusy?.opportunity_id ||
                o?._id === checkBusy?.opportunity_id
            ) || null;

          console.log("checkContactExistsInCampaign found", found);

          const campaignDetails = await previewCampaignDetails(checkBusy?._id);
          setPrevCampDetails(campaignDetails);
          console.log(
            "checkContactExistsInCampaign campaignDetails",
            campaignDetails
          );

          const curCampDetail = campaignDetails?.campaign?.[0];
          const campaignContacts =
            campaignDetails?.contacts[0]?.map(parseContact);
          const templatehist = campaignDetails?.templates?.[0];
          const finalTick = curCampDetail?.active_status;
          console.log("campaignDetails", campaignDetails);

          if (Object.keys(curCampDetail || {})?.length > 0) {
            dispatch({
              type: "MARK_COMPLETED",
              payload: STEP_IDS.CAMPAIGN_INIT,
            });
          }
          if (campaignContacts?.length > 0) {
            dispatch({ type: "MARK_COMPLETED", payload: STEP_IDS.CONTACT });
            setCurrentStepIndex(1);
          }
          if (templatehist?.length > 0 && finalTick == 1) {
            dispatch({
              type: "MARK_COMPLETED",
              payload: STEP_IDS.EMAIL_REACHOUT,
            });
          }
          // setDomain(campaignDetails?.search_list?.[0]?.domain);
          setSelectedContacts(campaignContacts);
          setSearchHist(curCampDetail?.search_list?.[0]);
          setCurrentCampDetails({
            campaignName: curCampDetail?.title,
            emailGenerationCount: curCampDetail?.email_generation_count,
            campaignContext: curCampDetail?.context,
            startDate: formatDateToYMD(
              new Date(curCampDetail?.start_date || null)
            ),
            products: curCampDetail?.products,
            daysFrequency: 3,
            account: curCampDetail?.account,
            opportunityId: curCampDetail?.opportunity_id,
            campaignId: curCampDetail?._id,
            campActive: curCampDetail?.active_status,
          });
        } else {
          console.log("oppDetail", oppDetail);
          if (Object.keys(oppDetail || {})?.length > 0) {
            setCurrentCampDetails({
              // case from opp map -> auto nurture in tro
              campaignName: oppDetail?.opportunity_name,
              // emailGenerationCount: curCampDetail?.email_generation_count,
              campaignContext: oppDetail?.opportunityDescription,
              startDate: formatDateToYMD(new Date()),
              products: oppDetail?.mappedProducts?.map((item)=>({name:item,description:""})),
              daysFrequency: 3,
              account: accountName,
              opportunityId: oppDetail?.opportunityId,
              campActive: false,
            });
          } else {
            // case from tro global
            setCurrentCampDetails({
              startDate: formatDateToYMD(new Date()),
              // products: curCampDetail?.products,
              daysFrequency: 3,
              account: accountName,

              campActive: false,
            });
          }
          setDataLoading(false);
        }
      } catch (error) {
        console.log("error while mounting", error);
      } finally {
        setDataLoading(false);
      }
    }

    bootstrap();
  }, []);

  useEffect(() => {
    if (!currentCampDetials?.campaignId) return;

    let active = true;
    let timerId = null;
    let tries = 0;
    const MAX_TRIES = 60; // ~5 minutes @ 5s
    const controller = new AbortController();

    // Set loading once at start
    // setEmailLoading(true);

    const poll = async () => {
      if (!active) return;
      try {
        const resp = await getContactWiseTemplates(
          currentCampDetials?.campaignId,
          {
            signal: controller.signal,
          }
        );
        if (!active) return;

        if (templatesReady(resp)) {
          setEmailsList(resp);
          active = false;
          return; // stop polling
        }

        if (++tries < MAX_TRIES && active) {
          timerId = setTimeout(poll, 5000);
        } else {
          // setEmailLoading(false);
        }
      } catch (err) {
        if (!active) return;
        console.error("❌ Poll error:", err);
        if (++tries < MAX_TRIES) {
          timerId = setTimeout(poll, 5000);
        } else {
          // setEmailLoading(false);
        }
      }
    };
    async function getPreviewDetails() {
      if (currentCampDetials?.campActive) {
        const analyticsResp = await getAnalyticsByCampId(
          currentCampDetials?.campaignId
        );
        const foundContactDetail = analyticsResp?.data
          ?.map((f) => f?.queue_items)
          .flat();
        const savedContactDetail = prevCampDetails?.contactwise_templates?.[0];

        const savedTemplates = savedContactDetail;

        const modifiedSaved = savedTemplates.map((eachItem) => {
          const modifiedTemplatesPerContact = eachItem?.templates?.map((ei) => {
            const foundContact = foundContactDetail.find(
              (fi) => fi?.template_id?.["$oid"] == ei?._id
            );
            console.log(
              "foundContactDetail foundContact",
              eachItem,
              ei,
              foundContact
            );
            if (foundContact?.sent) {
              // item.recievedDate = formatDateWithTime(foundEmail?.receivedDateTime);
              ei.sent = foundContact?.sent;
              ei.isReplied = foundContact?.is_replied;
              ei.isBounced = foundContact?.is_bounced;
              ei.isOpened = foundContact?.is_opened;
              ei.replies = foundContact?.sent_emails?.[0]?.replies?.map(
                (rep) => ({
                  subject: rep?.subject,
                  bodycontent: rep?.body?.content,
                  id: rep?.id,
                  recievedDate: formatDateWithTime(rep?.receivedDateTime, {
                    use12Hour: true,
                  }),
                  sender: rep?.sender?.emailAddress?.name,
                })
              );
            }
            ei.sent = foundContact?.sent;

            return ei;
          });
          return { ...eachItem, templates: modifiedTemplatesPerContact };
        });

        setEmailsList(modifiedSaved);
        console.log("modifiedSaved", modifiedSaved);
      } else {
        poll();
      }
    }

    // start immediately

    getPreviewDetails();

    return () => {
      active = false;
      controller.abort();
      if (timerId) clearTimeout(timerId);
      // setEmailLoading(false);
    };
  }, [currentCampDetials?.campaignId]);

  console.log("currentCampDetials persist", currentCampDetials);


  const isFormValid =
  Boolean(currentCampDetials?.campaignName?.trim()) &&
  Number(currentCampDetials?.emailGenerationCount) > 0 &&
  Boolean(currentCampDetials?.startDate) &&
  Array.isArray(currentCampDetials?.products) &&
  currentCampDetials?.products.length > 0;


const btnDisabled = currentCampDetials?.campActive || !isFormValid;

  const stepsConfig = useMemo(
    () => [
      {
        id: STEP_IDS.CAMPAIGN_INIT,
        title: "Setup",
        component: (
          <div
            style={{
              // position: "absolute",
              // bottom: 0,
              // left: 0,
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <span
              style={{
                padding: "1rem",
                // position: "absolute",
                // top: 0,
                width: "100%",
                // maxHeight: "85%",
                // overflowY: "auto",
              }}
            >
              <WarningForNurture
                accountName={accountName}
                contactId={contactId}
                clientName={clientName}
                oppId={currentCampDetials?.opportunityId}
                setIsContinueDisabled={setIsContinueDisabled}
              />
              <AutoNurtureHelperCard />
              <ReachoutInit
                currentCampDetials={currentCampDetials}
                allOpps={allOpps}
                allProducts={userWiseProductList || []}
                selectedOpportunity={{
                  _id: currentCampDetials?.opportunityId,
                  opportunity_name: currentCampDetials?.campaignName,
                }}
                setSelectedOpportunity={(val) => {
                  console.log("sapii", val);
                  setCurrentCampDetails((prev) => ({
                    ...prev,
                    opportunityId: val?.opportunity_id,
                    campaignName: val?.opportunity_name,
                    campaignContext: val?.opportunity_description,
                    products: val?.mapped_products?.map((item) => ({
                      name: item,
                      description: "",
                    })),
                  }));
                }}
                emailsPerContact={currentCampDetials?.emailGenerationCount}
                setEmailsPerContact={(val) =>
                  setCurrentCampDetails((prev) => ({
                    ...prev,
                    emailGenerationCount: val,
                  }))
                }
                startDate={currentCampDetials?.startDate}
                setStartDate={(val) =>
                  setCurrentCampDetails((prev) => ({
                    ...prev,
                    startDate: val,
                  }))
                }
                selectedProducts={currentCampDetials?.products || []}
                setSelectedProducts={(val) => {
                  console.log("first val", val);
                  setCurrentCampDetails((prev) => ({
                    ...prev,
                    products: val,
                  }));
                }}
              />
            </span>

            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
                alignItems: "flex-end",
                padding: "0.5rem",
                backgroundColor: "rgb(242, 246, 251)",
                position: "fixed",
                maxHeight: "15%",
                bottom: 0,
                left: 0,
              }}
            >
              <SimpleThemedButton
                btnDisabled={btnDisabled}
                buttonText="Generate Personalised Emails"
                onBtnClick={(e) => {
                  handleInitAutoNurtureFromReachOut(e);
                  dispatch({
                    type: "MARK_COMPLETED",
                    payload: STEP_IDS.CAMPAIGN_INIT,
                  });
                  setCurrentStepIndex(1);
                }}
              />
            </div>
          </div>
        ),
      },
      {
        id: STEP_IDS.EMAIL_REACHOUT,
        title: "Email Reachout",
        component: (
          <>
            <NurtureCampaignEmailReachOutV2
              stepDispatch={() => {}}
              stepId={STEP_IDS.EMAIL_REACHOUT}
              currentCampDetails={currentCampDetials}
              setCurrentStepIndex={setCurrentStepIndex}
              emails={emailsList}
              setEmails={setEmailsList}
              selectedContacts={selectedContacts}
              setSelectedContacts={setSelectedContacts}
              sideCardCloseFunc={setShowMoreModal}
              skipReview={true}
            />
          </>
        ),
      },
    ],
    [currentCampDetials, emailsList]
  );

  const childrenComp = (
    <>
      <DynamicStepper
        stepsConfig={stepsConfig}
        completedSteps={completedSteps}
        currentStepIndex={currentStepIndex}
        setCurrentStepIndex={setCurrentStepIndex}
        // compInitiating={compInitiating}
        campaignStartDate={campaignStartDate}
        today={today}
        campActive={currentCampDetials?.campActive}
      />

      {campaignStartDate < today && !currentCampDetials?.campActive && (
        <DynamicAlertDialog
          title="Date Alert"
          message={
            <>
              <UpdateNurtureDate
                handleDateUpdatePostActions={async (newDate) => {
                  if (currentCampDetials?.campaignId) {
                    try {
                      await changeCampaignDate(
                        newDate,
                        currentCampDetials?.campaignId,
                        user?.id
                      );
                    } catch (error) {
                      console.error("changeCampaignDate error", error);
                    } finally {
                      setCurrentCampDetails((prev) => ({
                        ...prev,
                        startDate: formatDateToYMD(new Date(newDate)),
                      }));
                    }
                  }
                }}
              />
            </>
          }
          type="info"
          autoShow={true}
        />
      )}
    </>
  );

  /* ---------- Render ---------- */

  if (!dataLoading && !isCalendarConnected) {
    return (
     <div  style={{width:"99%"}} className="connect_calendar_card mb-3 m-2 ">
        <div className="row">
          <div className="col-md-6">
            <div className="connect_calendar_block">
              <div className="connect_calendar_icon">
                <FeatherIcon.Mail className="calendar_fa" />
              </div>
              <div className="connect_para_block">
                <p className="connect_calendar_head">Connect your calendar </p>
                <p className="connect_para">
                  Connect with your Outlook to automate Campaign
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <span className="connect_calendar_btnblock">
              <Button
                variant="primary"
                type="submit"
                className="pull-right connect_calendar_btn"
                onClick={() => handleOutlookLogin()}
              >
                {" "}
                Connect your calendar{" "}
              </Button>
            </span>
          </div>
        </div>
      </div>
    );
  }

  if (dataLoading) {
    return (
      <div
        style={{
          width: "100%",
          height: "40vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <GeneratingLoader />
      </div>
    );
  }

  return (
    <WarningForNurtureGate
      contextType="Comtact"
      accountName={accountName}
      contactId={contactId}
      clientName={clientName}
      oppId={currentCampDetials?.opportunity_id}
      children={childrenComp}
    />
  );
}

export default ReachoutV3Wrapper;
